import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import './index.scss';
const LimitMessage = ({ auth, limitUsageClear }) => {
  const handleOverlayClick = (e) => {
  };

  const handleClose = () => {
    limitUsageClear();
  };

  const handleSave = () => {
    limitUsageClear();
    window.open('/settings/Billing_usage/subscription', '_blank');
  };

  if (!auth?.limitUsage) return null;
  return (
    <div
      className={`limit-message-overlay ${auth?.limitUsage ? 'open' : ''}`}
      onMouseDown={handleOverlayClick}
    >
      <div
        className="limit-message-modal"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <p className="limit-message-modal-title">
          {I18n.t(`errors.limitMessage.${auth?.limitUsage?.type}.title`)}
        </p>
        <div className="limit-message-modal-content">
          <p className="limit-message-modal-description">
            {I18n.t(
              `errors.limitMessage.${auth?.limitUsage?.type}.description`,
              {
                limitation: auth?.limitUsage?.limitation,
              }
            )}
          </p>

          <div className="limit-message-modal-footer">
            <Button className="btn-cancel mr-3" onClick={handleClose}>
              <Translate value="errors.limitMessage.cancel" />
            </Button>
            <Button className="btn-save" onClick={handleSave}>
              <Translate value="errors.limitMessage.upgrade" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitMessage;
